import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

const MainLayout = () => {
 
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-1 p-4 w-full mt-16">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
